import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../CurrentUserStore';
import { findLinkBy } from '../../../Links';
import KeyMetrics from './KeyMetrics';
import LicenseInsights from './LicenseInsights';
import PopularCompetencies from './PopularCompetencies';
import RecentlyLoggedIn from './RecentlyLoggedIn';
import ImpactSummary from './ImpactSummary';

function RightSideComponents() {
  return (
    <div className="w-[60%] ml-[6%]">
      <KeyMetrics />
      <ImpactSummary />
      <div className="w-full flex flex-wrap justify-between">
        <RecentlyLoggedIn />
        <PopularCompetencies />
      </div>
      {findLinkBy({ rel: 'product-licenses-lima' }, currentUserStore.links)
        .map(() => <LicenseInsights />)
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(RightSideComponents);
